export * from './identity-details.trait';
export * from './add-document.trait';
export * from './pep-details.trait';
export * from './upload-documents.trait';
export * from './company-registration.trait';
export * from './bank-accounts.trait';
